import { TagReference } from "../../models";

export const bulkApplyUserTags = async (
    API_URL: string,
    token: string,
    employerId: string,
    employeeIds: string[],
    tags: TagReference[]
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/employees/tags`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            employeeIds,
            tags
          })
        }
    );

    if(!response.ok) {
      throw new Error("Failed to apply tags to employees");
    }

    const responseBody = await response.json();
    return responseBody.jobId;
}
